import { useDispatch, useSelector } from "react-redux";
import {
  initState,
  submitData,
} from "../../../../modules/reducers/agreePrivacyTerm/agreePrivacy";
import { useEffect, useState } from "react";
import decryptPhoneNumberApi from "../../../../api/decrypt/decryptPhoneNumberApi";
import { TroubleReportApi } from "./../api/TroubleReportApi";
import { getPhoneNumber } from "../../../../modules/reducers/decryptPhoneNumber/decryptPhoneNumber";

const useRegisterTrouble = () => {
  const dispatch = useDispatch();

  const phoneNumber = useSelector(
    (state) => state.decryptPhoneNumber.phoneNumber
  );
  const branchId = useSelector((state) => state.checkArsStatus.branchId);
  const branchName = useSelector((state) => state.checkArsStatus.branchName);
  const tempUserId = useSelector((state) => state.checkArsStatus.userId);
  const userId = tempUserId??"".replaceAll(' ', '+');

  const status = useSelector((state) => state.agreePrivacy.status);
  const loading = useSelector((state) => state.agreePrivacy.loading);

  const [activeTab, setActiveTab] = useState("문자");

  const [formData, setFormData] = useState({
    reply_type: "PHONE",
    phone: phoneNumber,
    email: "",
    store_code: branchId,
    store_name: branchName,
    cust_name: "",
    context: "",
    audit: {
      account: userId,
      api_name: "assist",
    },
  });

  const [emailForm, setEmailForm] = useState({
    id: "",
    domain: "",
  });

  const [modalIsOpen, setIsOpen] = useState(false);

  const openModal = () => {
    setIsOpen(true);
  };

  const closeModal = () => {
    setIsOpen(false);
  };

  const categories = {
    문자: "SMS",
    이메일: "EMAIL",
    전화: "PHONE",
  };
  const categoryKeys = Object.keys(categories);

  const [showError, setShowError] = useState({
    id: false,
    domain: false,
    context: false,
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleTabClick = (tab) => {
    setActiveTab(tab);
    setFormData((prev) => ({
      ...prev,
      reply_type: categories[tab],
    }));
  };

  const handleEmail = (e) => {
    const { name, value } = e.target;
    setEmailForm((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleOnsubmit = (e) => {
    e.preventDefault();

    let requiredFields = [];
    let errors = {};
    let allFieldsValid = true;
    if (formData.reply_type === "EMAIL") {
      requiredFields = ["email", "context"];
    } else if (formData.reply_type === "PHONE") {
      requiredFields = ["context"];
    } else if (formData.reply_type === "SMS") {
      requiredFields = ["context"];
    }
    requiredFields.forEach((field) => {
      if (!formData[field]) {
        errors[field] = true;
        allFieldsValid = false;
      }
    });

    setShowError(errors);

    if (allFieldsValid) {
      const api = TroubleReportApi();
      const data = {};
      data.reply_type = formData.reply_type;
      data.store_code = formData.store_code;
      data.store_name = formData.store_name;
      data.audit = formData.audit;
      data.context = formData.context;
      data.cust_name = formData.cust_name;

      if (formData.reply_type === "EMAIL") {
        data.email = formData.email;
      } else if (formData.reply_type === "PHONE") {
        data.phone = formData.phone;
      } else if (formData.reply_type === "SMS") {
        data.phone = formData.phone;
      }
      dispatch(submitData({ ...api, data }));
    }
  };

  useEffect(() => {
    if (
      phoneNumber !== null &&
      branchId !== null &&
      branchName !== null &&
      userId !== null
    ) {
      setFormData((prev) => ({
        ...prev,
        phone: phoneNumber,
        store_code: branchId,
        store_name: branchName,
        account: userId,
      }));
    }
  }, [phoneNumber, branchId, branchName, userId]);

  useEffect(() => {
    if (userId !== null) {
      const api = decryptPhoneNumberApi();
      const data = {
        data: userId,
        audit: {
          account: "erody-front",
          api_name: "erody-front",
        },
      };
      dispatch(getPhoneNumber({ ...api, data }));
    }
  }, [userId]);

  useEffect(() => {
    if (
      emailForm.id !== null &&
      emailForm.id !== "" &&
      emailForm.domain !== null &&
      emailForm.domain !== ""
    ) {
      setFormData((prev) => ({
        ...prev,
        email: `${emailForm.id}@${emailForm.domain}`,
      }));
    }
  }, [emailForm]);

  useEffect(() => {
    if (status === true) {
      dispatch(initState());
      openModal();
    }
  }, [status]);

  return {
    categoryKeys,
    activeTab,
    handleTabClick,
    formData,
    handleEmail,
    handleOnsubmit,
    handleChange,
    emailForm,
    showError,
    loading,
    modalIsOpen,
    closeModal,
  };
};

export default useRegisterTrouble;
